import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Heading } from "@chakra-ui/react";
import { CurvedContainer } from "~/components";
import { useCurrentDiagnosticUser } from "~/hooks/useCurrentDiagnosticUser";

const storedFirstTime = sessionStorage.getItem("firstTime");
const firstTime = JSON.parse(storedFirstTime || "false");

const partialKey = firstTime
  ? ("dashboard.welcome.firstTime" as const)
  : ("dashboard.welcome.back" as const);

export const Title: FC = () => {
  const user = useCurrentDiagnosticUser();
  const { t } = useTranslation();

  if (!user) return null;

  const { firstName } = user;

  const key = firstName
    ? (`${partialKey}.named` as const)
    : (`${partialKey}.anonymous` as const);

  const bg = "var(--chakra-colors-newDarkGreen-800)";

  return (
    <Box mb={{ base: 6, md: 16 }} w="full">
      <CurvedContainer bg={bg} bottom>
        <Flex
          align="center"
          justify="center"
          textAlign="center"
          w="full"
          zIndex={2}
        >
          <Heading
            color="fg-on-accent"
            fontFamily="Moderat Extended"
            mt={{ base: 4, md: 6, lg: 8 }}
            mb={{ base: -1, lg: -2 }}
            variant="th-h1-default"
          >
            {t(key, { firstName })}
          </Heading>
        </Flex>
      </CurvedContainer>
    </Box>
  );
};
